import React from 'react'

import { CloseButton } from '../../ui';

const Model = ({ ...props }) => {
    const {
        heading = "",
        headingClass = "",
        content = "",
        contentClass = "",
        setIsModelOpen } = props

    const handleClose = (e) => {
        e.stopPropagation();
        setIsModelOpen(false);
    };
    return (
        <>
            <div className="flex fixed top-0 left-0 z-10 justify-center items-center w-full h-full bg-gray-800 bg-opacity-50"
          
            >
                <div className='container'>
                    <div className="relative py-5 mx-auto w-full bg-white rounded-3xl shadow-md 2xl:w-1/3 lg:w-1/2 sm:w-3/4 shadow-cyan-200/40 md:py-10"
                    //  style={{ boxShadow: '0 0 16px #0D98BA' }}
                    >
                        <div className='absolute top-3 right-3  cursor-pointer text-2xl text-[#0D98BA] p-2 rounded-full '>
                            <CloseButton className="" onClick={(e) => handleClose(e)} />
                        </div>
                        <div className="flex flex-col justify-center">
                            <p className={`text-lg font-semibold text-center ${headingClass} md:text-2xl xl:text-3xl`}>
                                {heading}
                            </p>
                            <div className={`py-5 mx-5 md:px-8 ${contentClass}`}>
                                {content}
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        </>
    )
}

export default Model
